export default __webpack_public_path__ + "static/media/whatsapp.8505d021.svg";